import type { StatCard as StatCardType } from '../../../../types'
import { StatCard } from './StatCard'

type StatCardRowProps = {
  highlightStat: StatCardType
  stats: StatCardType[]
}

export const StatCardRow = ({ highlightStat, stats }: StatCardRowProps) => (
  <section
    aria-label="Key figures"
    className="grid grid-cols-1 gap-[19px] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[222px_repeat(4,minmax(0,1fr))]"
  >
    <StatCard stat={highlightStat} variant="highlight" />
    {stats.map((stat) => (
      <StatCard key={stat.id} stat={stat} />
    ))}
  </section>
)
